import React from "react";
import { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "./MapComponent.scss";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
    iconUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
    shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

const MapComponent = ({
    data = [],
    center = [40.0, -4.0],
    zoom = 6,
    height = "100%",
    width = "100%",
    modalContent = null,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [modalTitle, setModalTitle] = useState("Detalle del centro");
    const detailButtonText = "Ver detalles";

    const mapData =
        data &&
        data.filter((x) => x.latitud != 0 && x.latitud != null).length > 0
            ? data.filter((x) => x.latitud != 0 && x.latitud != null)
            : [];

    const handleMarkerClick = (marker) => {
        setSelectedMarker(marker);
        setIsModalOpen(true);
        setModalTitle(marker.nombre || "Detalle del centro");
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedMarker(null);
    };

    const renderPopupContent = (marker) => {
        // Si hay contenido personalizado, usarlo
        // if (customPopupContent && typeof customPopupContent === "function") {
        //     return customPopupContent(marker);
        // }

        // Contenido por defecto
        return (
            <div className="marker-popup">
                <h4>{marker.nombre}</h4>
                <p>{marker.direccion}</p>
                {modalContent && (
                    <Button
                        variant="filled"
                        onClick={() => handleMarkerClick(marker)}
                    >
                        {detailButtonText}
                    </Button>
                )}
            </div>
        );
    };

    return (
        <div className="map-component">
            <MapContainer
                center={center}
                zoom={zoom}
                style={{ height, width }}
                className="map-container"
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {mapData.map((marker) => (
                    <Marker
                        key={marker.id}
                        position={[marker.latitud, marker.longitud]}
                    >
                        <Popup width={200}>{renderPopupContent(marker)}</Popup>
                    </Marker>
                ))}
            </MapContainer>

            <Modal isOpen={isModalOpen} onClose={closeModal} title={modalTitle}>
                {modalContent && selectedMarker && modalContent(selectedMarker)}
            </Modal>
        </div>
    );
};

export default MapComponent;
